import { dt, brDec } from 'oderon-commons/src/formatters'
import { preProcessSpec } from 'oderon-commons/src/tables'
import { sanitizeTechName } from '../../../utils'

export const defCodes = ['id', 'name', 'orgLabels', 'cards']

export const fullSpec = preProcessSpec({
  defaultSortable: true,
  defOrder: 'name asc',
  defCodes,
  columns: [
    { t: 'ID|', d: 'id', color: '#ccc', w: 80 },
    {
      t: 'Nome',
      code: 'name',
      d: (row) => sanitizeTechName(row.name),
      w: 400
    },
    {
      t: 'Valor Instalação|',
      d: 'installValue',
      f: brDec,
      selectable: true
    },
    {
      t: 'Valor Remoção|',
      d: 'removeValue',
      f: brDec,
      selectable: true
    },
    { t: 'Organizações', d: 'orgLabels' },
    {
      t: 'Crachás',
      code: 'cards',
      d: (x) => (x.cards || []).map((c) => c.serial).join(', ')
    },
    {
      t: 'Criado em|',
      d: 'createdAt',
      sortBy: 'createdAt',
      w: 220,
      code: 'createdAt',
      selectable: true,
      f: dt
    },

    {
      t: 'Atualizado em|',
      d: 'updatedAt',
      sortBy: 'updatedAt',
      w: 220,
      code: 'updatedAt',
      selectable: true,
      f: dt
    },
    {
      t: 'Desativado em|',
      d: 'deletedAt',
      sortBy: 'deletedAt',
      w: 220,
      code: 'deletedAt',
      selectable: true,
      f: dt
    }
  ]
})
